import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { SUPPORTED_LOCALES } from "@/i18n";

/**
 * Strip the leading locale segment so language switches
 * (which only change the prefix) don't count as navigation.
 */
function stripLocale(pathname: string) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length && (SUPPORTED_LOCALES as readonly string[]).includes(parts[0])) {
    parts.shift();
  }
  return "/" + parts.join("/");
}

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prev = useRef<string>(stripLocale(pathname));
  useEffect(() => {
    const current = stripLocale(pathname);
    if (current !== prev.current) {
      window.scrollTo(0, 0);
      prev.current = current;
    }
  }, [pathname]);
  return null;
}